import { formatPartnerEventArchivedAt } from '../Events/partnerEventArchive';

export const isPartnerCommunityArchived = (channel) =>
  Boolean(channel?.isArchived ?? channel?.deletedAt);

/** Same partner API deletedAt contract as events (`yy-MM-dd HH:mm:ss`). */
export const formatPartnerCommunityArchivedAt = (deletedAt) =>
  formatPartnerEventArchivedAt(deletedAt);
